<app-header></app-header>
<div class="qg-global-breadcrumb qg-breadcrumb">
  <div class="container-fluid qg-site-width">
    <nav id="qg-breadcrumb" aria-label="breadcrumb" class="qg-breadcrumb-nav row">
      <ol class="qg-breadcrumb-list">
        <li class="qg-breadcrumb-list-item">
          <a href="https://www.qld.gov.au/" class="qg-breadcrumb-list-item__link">
            Home
          </a>
        </li>
        <li class="qg-breadcrumb-list-item">
          <a routerLink="home" class="qg-breadcrumb-list-item__link">
            Online Self-Assessable Code Notification
          </a>
        </li>
      </ol>
    </nav>
  </div>
</div>
<div class="container-fluid qg-site-width">
  <div id="qg-content">
    <div id="qg-three-col-nav" class="row wide">

      <nav class="qg-section-nav" aria-label="side navigation" role="navigation">
        <h2><a routerLink="home">Online Self-Assessable Code Notification</a></h2>
        <ul aria-label="section navigation">
          @for (rs of sms.routeStatesVisible$ | async; track rs; let i = $index) {
            <li [ngClass]="{ 'disabled-menu-item': !rs.isEnabled }">
              <a [routerLink]="rs.isEnabled ? rs.route : undefined" routerLinkActive="active-router-link"
                [ngClass]="{ 'active-router-link': rs.isEnabled && this.router.url.toLowerCase().includes(rs.route.toLowerCase()) }">
                <span class="nav-num">{{i + 1}}</span>{{rs.name}}
              </a>
            </li>
          }
        </ul>
      </nav>

      <div id="qg-primary-content" role="main">
        <h1>Online notification for accepted development vegetation clearing codes</h1>
        @if (lss.isInErrorState$ | async) {
          <div style="margin-bottom: 10px;" class="alert alert-warning mt-4">
            <h2><i class="fa fa-exclamation-triangle"></i>Unexpected Error</h2>
            <p> We've automatically logged the details of this error. Please restart your submission and try again in a
              few minutes, or <a [href]="'mailto:' + errorMailToAddress">send us an email</a>.</p>
              <strong>Reference Code:</strong> Unexpected Error
            </div>
          }
          <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>

        <aside id="qg-secondary-content">
          <div class="qg-aside qg-contact" role="complementary">
            <h2><span class="fa fa-phone" aria-hidden="true"></span>Contact us</h2>
            <p>For more information about vegetation management, please <a href="https://www.resources.qld.gov.au">contact
            us</a>.</p>
            <p>For assistance with completing this notification, please <a target="_blank"
              href="https://www.qld.gov.au/__data/assets/pdf_file/0029/552755/user-guide-online-self-assessable-code-notification.pdf">access
            the user guide</a> or watch the <a target="_blank"
            href="https://www.youtube.com/watch?v=0qhtn06BFwo">online
          Tutorial</a>.</p>
        </div>
      </aside>
    </div>
  </div>
</div>

<app-footer></app-footer>

<app-mat-spinner-overlay overlay="true"></app-mat-spinner-overlay>
